module.exports = __webpack_public_path__ + "media/images/mailer/right-rounded-border-red-a704d8ec0bed82de5953284a42cbd1a5.png";